/* core-cart-thresholds: vezi snippets/core-cart-thresholds.liquid */
if (!customElements.get('core-cart-thresholds')) {
  const last = {};
  let ready = false;

  customElements.define(
    'core-cart-thresholds',
    class CoreCartThresholds extends HTMLElement {
      connectedCallback() {
        const fill = this.querySelector('.core-ct__fill');
        const now = {
          p: fill ? fill.style.getPropertyValue('--core-ct-p') : '',
          text: (this.querySelector('.core-ct__text')?.textContent || '').replace(/\s+/g, ' ').trim(),
        };
        const prev = last[this.dataset.context] || {};
        last[this.dataset.context] = now;
        if (!ready) return;

        if (fill && prev.p && prev.p !== now.p) {
          fill.style.setProperty('--core-ct-p', prev.p);
          getComputedStyle(fill).transform;
          requestAnimationFrame(() => fill.style.setProperty('--core-ct-p', now.p));
        }

        const live = this.querySelector('.core-ct__live');
        if (live && now.text && now.text !== prev.text) {
          setTimeout(() => {
            live.textContent = now.text;
            setTimeout(() => (live.textContent = ''), 5000);
          }, 150);
        }
      }
    }
  );
  ready = true;
}
